@if (message) {
  <h1 class="mb-0">
    {{message}}
  </h1>
}

<div class="vs-grow">
  <img class="logo" src="/assets/images/vs-icon.svg">
</div>
